/* eslint-disable no-undef */
import { useConfigurationStore } from "@/stores/configurationModule";
import { useConfiguratorStore } from "@/stores/configurator";
export default function useCanvasEventListeners(canvas, printSide) {
  // STORES
  // ------------------------------------------------
  const configurationStore = useConfigurationStore();
  const {
    fabricCanvases
  } = storeToRefs(configurationStore);
  const {
    setActiveObjects
  } = configurationStore;
  const configuratorStore = useConfiguratorStore();
  const {
    isShiftDown
  } = storeToRefs(configuratorStore);

  // ------------------------------------------------

  // FABRIC SPECIFIC EVENTS
  // ------------------------------------------------
  canvas.on('selection:created', () => {
    /**
     * @NOTE: When having two canvases (inside and outside) selecting object
     * If there is an object selected on one canvas and you click an object
     * on the other canvas, the object on the first canvas will be deselected
     * after the second one is selected. Therefore active objects will be set to
     * empty arrays. To prevent this, we need to wait for the next tick to set the
     * active objects.
     */
    setActiveObjects(canvas.getActiveObjects());
  });
  canvas.on('selection:updated', () => {
    setActiveObjects(canvas.getActiveObjects());
  });
  canvas.on('mouse:down', () => {
    // @TODO: Need to have further discussion with Nikola (what about different types of objects)
    // if(!isMetaKeyDown.value) {
    // }

    /**
     * @NOTE: Improve: discarding objects don't have to be done on every mouse down
     * Do check before
     */
    const otherCanvasIndex = printSide === 'inside' ? 0 : 1;
    const otherCanvas = fabricCanvases.value[otherCanvasIndex];
    otherCanvas?.discardActiveObject().renderAll();
  });
  canvas.on('selection:cleared', () => {
    setActiveObjects(canvas.getActiveObjects());
  });
  canvas.on('object:rotating', () => {
    const selection = canvas.getActiveObject();
    if (selection.originX !== 'center' && selection.originY !== 'center') {
      selection.top += selection.getScaledHeight() / 2;
      selection.left += selection.getScaledWidth() / 2;
    }

    // Fixes rotation to 15 deg increments if shift is pressed down
    if (isShiftDown.value) {
      selection.rotate(15 * Math.round(selection.angle / 15));
    }
  });
  // ------------------------------------------------
}